import { render, staticRenderFns } from "./FocusMagnetLink.vue?vue&type=template&id=2dd1f365&scoped=true&"
import script from "./FocusMagnetLink.vue?vue&type=script&lang=js&"
export * from "./FocusMagnetLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd1f365",
  null
  
)

export default component.exports